export default __webpack_public_path__ + "media/color/mco-7ddfd514.svg";